var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdamantineRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74513 8.62529L1.49121 9.88416L2.74513 11.143L3.99905 9.88416L2.74513 8.62529Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.901 10.6153L3.59277 10.9247L3.90099 11.2342L4.20922 10.9247L3.901 10.6153Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72582 9.71456L4.12305 10.3197L4.72581 10.9248L5.32858 10.3197L4.72582 9.71456Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49824 10.7237L4.13281 12.0945L5.49824 13.4654L6.86367 12.0945L5.49824 10.7237Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8047 11.1775L7.16406 11.8206L7.8047 12.4638L8.44533 11.8206L7.8047 11.1775Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09555 12.4166L6.21191 13.3037L7.04821 14.1433L7.93185 13.2562L7.09555 12.4166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72751 9.89349L6.22363 10.3994L6.69806 10.8757L7.20194 10.3698L6.72751 9.89349Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96444 13.7219L6.56641 15.1254L7.88239 16.4466L9.28043 15.0431L7.96444 13.7219Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04586 13.0396L8.61035 13.4769L9.02061 13.8887L9.45612 13.4515L9.04586 13.0396Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5389 11.2928L9.24707 12.5897L10.4642 13.8116L11.756 12.5147L10.5389 11.2928Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9329 10.64L11.3428 11.2325L11.8982 11.7901L12.4883 11.1976L11.9329 10.64Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4146 9.52877L11.9717 9.97339L12.3883 10.3916L12.8311 9.94698L12.4146 9.52877Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29913 10.1944L8.42285 11.0742L9.24758 11.9021L10.1239 11.0224L9.29913 10.1944Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94421 0L0 7.97551L1.41181 9.39288L2.71204 8.08752L3.99293 9.37346L4.42287 8.94183L5.48359 10.0067L6.3271 9.15988L6.59935 9.4332L6.79721 9.23456L8.04835 10.4906L9.13286 9.40184L9.29651 9.56613L10.2561 8.60279L10.4792 8.82682L9.41702 9.89321L10.622 11.103L11.9297 9.79016L10.9136 8.77007L11.1159 8.56695L11.9297 9.38392L12.2347 9.07774L13.1853 10.0321L14.1315 9.08222L14.5183 9.47054L16 7.98297L7.94421 0ZM14.0318 7.91278H11.476L7.99628 4.50302L5.2411 7.20335H8.80111L7.99628 6.41476L7.5708 6.82996H6.33306L7.3774 5.80987L7.99628 5.2035L8.61515 5.80987L10.0374 7.20335L10.7619 7.91278H3.26397L7.36997 3.88918L7.99628 3.27533L8.62259 3.88918L12.0041 7.20335H12.8312L9.03617 3.48443L8.40985 2.87058L7.99628 2.46434L7.5827 2.87058L6.95639 3.48443L2.43682 7.91278H1.18419L6.33008 2.87058L6.95639 2.25674L7.36997 1.8505L7.99628 1.23665L8.62259 1.8505L9.03617 2.25674L9.66248 2.87058L14.8084 7.91278H14.0303H14.0318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdamantineRock);
export default __webpack_public_path__ + "static/media/adamantine-rock.736f43ec1fd7fbb3e3e153759f8f07a2.svg";
export { ForwardRef as ReactComponent };